export default {
  BFS: [
    "Aegean Airlines",
    "Aer Lingus",
    "Aeroflot",
    "Aerolineas Argentinas",
    "Aeromexico",
    "Air Arabia",
    "Air Astana",
    "Air Austral",
    "Air Baltic",
    "Air Belgium",
    "Air Canada",
    "Air Caraibes",
    "Air China",
    "Air Corsica",
    "Air Dolomiti",
    "Air Europa",
    "Air France",
    "Air India",
    "Air India Express",
    "Air Macau",
    "Air Malta",
    "Air Mauritius",
    "Air Namibia",
    "Air New Zealand",
    "Air North",
    "Air Seoul",
    "Air Serbia",
    "Air Tahiti Nui",
    "Air Transat",
    "Air Vanuatu",
    "AirAsia",
    "AirAsia X",
    "Aircalin",
    "Alaska Airlines",
    "Alitalia",
    "Allegiant",
    "American Airlines",
    "Asiana",
    "Austrian",
    "Avianca",
    "Azerbaijan Hava Yollary",
    "Azores Airlines",
    "Azul",
    "Bamboo Airways",
    "Bangkok Airways",
    "British Airways",
    "Brussels Airlines",
    "Caribbean Airlines",
    "Cathay Dragon",
    "Cathay Pacific",
    "Cayman Airways",
    "CEBU Pacific Air",
    "China Airlines",
    "China Eastern",
    "China Southern",
    "Condor",
    "Copa Airlines",
    "Croatia Airlines",
    "Czech Airlines",
    "Delta",
    "easyJet",
    "Edelweiss Air",
    "Egyptair",
    "EL AL",
    "Emirates",
    "Ethiopian Airlines",
    "Etihad",
    "Eurowings",
    "EVA Air",
    "Fiji Airways",
    "Finnair",
    "flydubai",
    "FlyOne",
    "French bee",
    "Frontier",
    "Garuda Indonesia",
    "Gol",
    "Gulf Air",
    "Hainan Airlines",
    "Hawaiian Airlines",
    "Helvetic Airways",
    "HK Express",
    "Hong Kong Airlines",
    "Iberia",
    "Icelandair",
    "IndiGo Airlines",
    "InterJet",
    "Japan Airlines",
    "Jeju Air",
    "Jet2",
    "JetBlue",
    "Jetstar",
    "Jin Air",
    "Kenya Airways",
    "KLM",
    "Korean Air",
    "Kulula",
    "La Compagnie",
    "LATAM",
    "Lion Airlines",
    "LOT Polish Airlines",
    "Lufthansa",
    "Luxair",
    "Malaysia Airlines",
    "Mango",
    "Middle East Airlines",
    "Nok Air",
    "Nordwind Airlines",
    "Norwegian Air International",
    "Norwegian Air Shuttle",
    "Norwegian Air Sweden",
    "Norwegian Air UK",
    "Oman Air",
    "Pakistan International Airlines",
    "Peach",
    "Pegasus Airlines",
    "Philippine Airlines",
    "Porter",
    "Qantas",
    "Qatar Airways",
    "Regional Express",
    "Rossiya - Russian Airlines",
    "Royal Air Maroc",
    "Royal Brunei",
    "Royal Jordanian",
    "RwandAir",
    "Ryanair",
    "S7 Airlines",
    "SAS",
    "Saudia",
    "Scoot Airlines",
    "Shanghai Airlines",
    "Silkair",
    "Silver",
    "Singapore Airlines",
    "Skylanes",
    "South African Airways",
    "Southwest",
    "SpiceJet",
    "Spirit",
    "Spring Airlines",
    "Spring Japan",
    "SriLankan Airlines",
    "Sun Country",
    "Sunclass Airlines",
    "Sunwing",
    "SWISS",
    "Swoop",
    "TAAG",
    "TACA",
    "TAP Portugal",
    "THAI",
    "tigerair Australia",
    "Transavia Airlines",
    "TUI UK",
    "TUIfly",
    "Tunis Air",
    "Turkish Airlines",
    "Ukraine International",
    "United",
    "Ural Airlines",
    "UTair Aviation",
    "Uzbekistan Airways",
    "Vietnam Airlines",
    "Virgin Atlantic",
    "Virgin Australia",
    "Vistara",
    "Viva Aerobus",
    "Volaris",
    "Volotea",
    "Vueling Airlines",
    "WestJet",
    "Wizzair",
    "Xiamen Airlines",
    "Other",
  ],
  //--------------------------------------------------------------------//
  BHX: [
    "Aegean",
    "Aer Lingus",
    "Air France",
    "Air India",
    "Aurigny Air Services",
    "Avanti Air",
    "Blue Islands",
    "Brussels Airlines",
    "Corendon Airlines",
    "Easyjet",
    "Emirates",
    "Enter Air",
    "Eurowings",
    "Gulf Air",
    "Jet2",
    "KLM Royal Dutch Airlines",
    "Loganair",
    "Lufthansa",
    "Pegasus",
    "Qatar Airways",
    "Ryanair",
    "SAS Scandinavian Airlines System",
    "Saudia",
    "Sun Express",
    "Swiss International Airlines",
    "TUI",
    "Turkish Airlines",
    "Vueling Airlines",
    "Wizz Air",
    "Other",
  ],
  //--------------------------------------------------------------------//
  BH2: [
    "Aegean",
    "Aer Lingus",
    "Air France",
    "Air India",
    "Aurigny Air Services",
    "Avanti Air",
    "Blue Islands",
    "Brussels Airlines",
    "Corendon Airlines",
    "Easyjet",
    "Emirates",
    "Enter Air",
    "Eurowings",
    "Gulf Air",
    "Jet2",
    "KLM Royal Dutch Airlines",
    "Loganair",
    "Lufthansa",
    "Pegasus",
    "Qatar Airways",
    "Ryanair",
    "SAS Scandinavian Airlines System",
    "Saudia",
    "Sun Express",
    "Swiss International Airlines",
    "TUI",
    "Turkish Airlines",
    "Vueling Airlines",
    "Wizz Air",
    "Other",
  ],
  //--------------------------------------------------------------------//
  DRW: [],
  //--------------------------------------------------------------------//
  FM1: [],
  //--------------------------------------------------------------------//
  FMM: [
    "Air India",
    "Emirates",
    "PIA",
    "Qatar Airways",
    "Turkmenistan Airways",
    "Aer Lingus",
    "Austrian Airlines",
    "Aegean Airlines",
    "Stobart Air",
    "Air France",
    "Blue Air",
    "Brussels Airlines",
    "Iberia Express",
    "KLML",
    "ufthansa",
    "SAS",
    "Swiss International Airlines",
    "Turkish Airlines",
    "Blue Islands",
    "Loganair",
    "Aurigny",
    "Eastern Airlines",
    "Easyjet",
    "Eurowings",
    "Jet2",
    "Ryanair",
    "Vueling Airlines",
    "Wizz Air",
    "Laudamotion",
    "TUI",
    "BH Air",
    "Enter Air",
    "Freebird",
    "Titan",
    "Other",
  ],
  //--------------------------------------------------------------------//
  HER: [],
  //--------------------------------------------------------------------//
  HVN: [],
  //--------------------------------------------------------------------//
  INV: [],
  //--------------------------------------------------------------------//
  IP1: [
    "Aegean Airlines",
    "Aer Lingus",
    "Aeroflot",
    "Aerolineas Argentinas",
    "Aeromexico",
    "Air Arabia",
    "Air Astana",
    "Air Austral",
    "Air Baltic",
    "Air Belgium",
    "Air Canada",
    "Air Caraibes",
    "Air China",
    "Air Corsica",
    "Air Dolomiti",
    "Air Europa",
    "Air France",
    "Air India",
    "Air India Express",
    "Air Macau",
    "Air Malta",
    "Air Mauritius",
    "Air Namibia",
    "Air New Zealand",
    "Air North",
    "Air Seoul",
    "Air Serbia",
    "Air Tahiti Nui",
    "Air Transat",
    "Air Vanuatu",
    "AirAsia",
    "AirAsia X",
    "Aircalin",
    "Alaska Airlines",
    "Alitalia",
    "Allegiant",
    "American Airlines",
    "Asiana",
    "Austrian",
    "Avianca",
    "Azerbaijan Hava Yollary",
    "Azores Airlines",
    "Azul",
    "Bamboo Airways",
    "Bangkok Airways",
    "British Airways",
    "Brussels Airlines",
    "Caribbean Airlines",
    "Cathay Dragon",
    "Cathay Pacific",
    "Cayman Airways",
    "CEBU Pacific Air",
    "China Airlines",
    "China Eastern",
    "China Southern",
    "Condor",
    "Copa Airlines",
    "Croatia Airlines",
    "Czech Airlines",
    "Delta",
    "easyJet",
    "Edelweiss Air",
    "Egyptair",
    "EL AL",
    "Emirates",
    "Ethiopian Airlines",
    "Etihad",
    "Eurowings",
    "EVA Air",
    "Fiji Airways",
    "Finnair",
    "flydubai",
    "FlyOne",
    "French bee",
    "Frontier",
    "Garuda Indonesia",
    "Gol",
    "Gulf Air",
    "Hainan Airlines",
    "Hawaiian Airlines",
    "Helvetic Airways",
    "HK Express",
    "Hong Kong Airlines",
    "Iberia",
    "Icelandair",
    "IndiGo Airlines",
    "InterJet",
    "Japan Airlines",
    "Jeju Air",
    "Jet2",
    "JetBlue",
    "Jetstar",
    "Jin Air",
    "Kenya Airways",
    "KLM",
    "Korean Air",
    "Kulula",
    "La Compagnie",
    "LATAM",
    "Lion Airlines",
    "LOT Polish Airlines",
    "Lufthansa",
    "Luxair",
    "Malaysia Airlines",
    "Mango",
    "Middle East Airlines",
    "Nok Air",
    "Nordwind Airlines",
    "Norwegian Air International",
    "Norwegian Air Shuttle",
    "Norwegian Air Sweden",
    "Norwegian Air UK",
    "Oman Air",
    "Pakistan International Airlines",
    "Peach",
    "Pegasus Airlines",
    "Philippine Airlines",
    "Porter",
    "Qantas",
    "Qatar Airways",
    "Regional Express",
    "Rossiya - Russian Airlines",
    "Royal Air Maroc",
    "Royal Brunei",
    "Royal Jordanian",
    "RwandAir",
    "Ryanair",
    "S7 Airlines",
    "SAS",
    "Saudia",
    "Scoot Airlines",
    "Shanghai Airlines",
    "Silkair",
    "Silver",
    "Singapore Airlines",
    "Skylanes",
    "South African Airways",
    "Southwest",
    "SpiceJet",
    "Spirit",
    "Spring Airlines",
    "Spring Japan",
    "SriLankan Airlines",
    "Sun Country",
    "Sunclass Airlines",
    "Sunwing",
    "SWISS",
    "Swoop",
    "TAAG",
    "TACA",
    "TAP Portugal",
    "THAI",
    "tigerair Australia",
    "Transavia Airlines",
    "TUI UK",
    "TUIfly",
    "Tunis Air",
    "Turkish Airlines",
    "Ukraine International",
    "United",
    "Ural Airlines",
    "UTair Aviation",
    "Uzbekistan Airways",
    "Vietnam Airlines",
    "Virgin Atlantic",
    "Virgin Australia",
    "Vistara",
    "Viva Aerobus",
    "Volaris",
    "Volotea",
    "Vueling Airlines",
    "WestJet",
    "Wizzair",
    "Xiamen Airlines",
    "Other",
  ],
  //--------------------------------------------------------------------//
  JER: [],
  //--------------------------------------------------------------------//
  LAX: [],
  //--------------------------------------------------------------------//
  LDY: [],
  //--------------------------------------------------------------------//
  ML1: [],
  //--------------------------------------------------------------------//
  NOC: [],
  //--------------------------------------------------------------------//
  NQY: [],
  //--------------------------------------------------------------------//
  NWI: [],
  //--------------------------------------------------------------------//
  NUE: [
    "Air India",
    "Emirates",
    "PIA",
    "Qatar Airways",
    "Turkmenistan Airways",
    "Aer Lingus",
    "Austrian Airlines",
    "Aegean Airlines",
    "Stobart Air",
    "Air France",
    "Blue Air",
    "Brussels Airlines",
    "Iberia Express",
    "KLML",
    "ufthansa",
    "SAS",
    "Swiss International Airlines",
    "Turkish Airlines",
    "Blue Islands",
    "Loganair",
    "Aurigny",
    "Eastern Airlines",
    "Easyjet",
    "Eurowings",
    "Jet2",
    "Ryanair",
    "Vueling Airlines",
    "Wizz Air",
    "Laudamotion",
    "TUI",
    "BH Air",
    "Enter Air",
    "Freebird",
    "Titan",
    "Other",
  ],
  //--------------------------------------------------------------------//
  PB1: [],
  //--------------------------------------------------------------------//
  PIT: [],
  //--------------------------------------------------------------------//
  PV1: [],
  //--------------------------------------------------------------------//
  RDU: [],
  //--------------------------------------------------------------------//
  RSW: [],
  //--------------------------------------------------------------------//
  SV1: [],
  //--------------------------------------------------------------------//
  SZG: [],
  //--------------------------------------------------------------------//
  YHM: [],
  //--------------------------------------------------------------------//
  SB2: [],
  //--------------------------------------------------------------------//
  SB3: [],
  //--------------------------------------------------------------------//
  SB4: [],
  //--------------------------------------------------------------------//
  SB5: [],
  //--------------------------------------------------------------------//
};
